import { ref } from 'vue';

const getWorktypes = () => {
    const worktypes_error = ref(null);
    const worktypes = ref(null);

    const loadWorktypes = async () => {
        
        try {
            let data = await fetch("/api/worktypes");

            if (!data.ok) {
                throw Error("Can't load data");
            }

            worktypes.value = await data.json();
            console.log('Worktypes', worktypes.value);
        } catch (err) {
            worktypes_error.value = err.message;
        }
    };

    // const closeProjectOpen = async (projectOpen) => {
     
    //     const id = projectOpen.id;

    //     const tokenResponse = await fetch( '/sanctum/csrf-cookie', {
    //         method: 'GET',
    //         credentials: 'include'
    //       });
    //       const token = decodeURIComponent(getCookie('XSRF-TOKEN'));

    //     const requestOptions = {
    //         method: 'PUT',
    //         headers: {
    //             'X-XSRF-TOKEN': token,
    //             'Content-Type': 'application/json'
    //         },
    //         body: JSON.stringify(projectOpen)
    //     };

    //     try {
    //         const response = await fetch('/api/projects/' + id, requestOptions);
    //         //console.log(requestOptions);
    //         if (!response.ok) {
    //             //console.log(response.status + ' - ' + response.statusText);
    //             projectOpen_error.value = response.status + ' - ' + response.statusText;
    //            console.log(projectOpen_error.value);
    //         }
    //         const data = await response.text();

    //     } catch (err) {
    //         projectOpen_error.value = err.message;
    //         console.log( err.message);
    //     }
    // };
     
    return { worktypes, worktypes_error, loadWorktypes};
}

export default getWorktypes;
